import type {
  IntakeAccessoryStatus,
  IntakeShipmentType,
  IntakeOwnershipType,
} from '@/services/equipment-intake.service';

// Shared across EquipmentIntakePage's existing modal form and the Equipment
// Intake Workspace (Feature 5) — kept in one place so both surfaces render
// identical selects/checklists rather than drifting.

export const SELECT_CLASS =
  'flex h-10 w-full rounded-lg border border-input bg-card px-3 py-2 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1 disabled:opacity-50';

export const MAX_PHOTOS = 5;
export const MAX_PHOTO_BYTES = 500 * 1024;
export const PHOTO_MIME = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
export const ATTACHMENT_MIME = 'image/jpeg,image/png,image/webp,application/pdf';

export const SHIPMENT_TYPES: IntakeShipmentType[] = [
  'COURIER',
  'TRANSPORT',
  'HAND_DELIVERY',
  'PICKUP',
  'OTHER',
];

export const OWNERSHIP_TYPES: IntakeOwnershipType[] = [
  'CUSTOMER',
  'COMPANY',
  'RENTAL',
  'DEMO',
  'STOCK',
];

export const ACCESSORY_STATUSES: IntakeAccessoryStatus[] = ['RECEIVED', 'MISSING', 'DAMAGED'];

export const ACCESSORY_STATUS_LABEL: Record<IntakeAccessoryStatus, string> = {
  RECEIVED: 'Received',
  MISSING: 'Missing',
  DAMAGED: 'Damaged',
};

export const ACCESSORY_STATUS_STYLE: Record<IntakeAccessoryStatus, string> = {
  RECEIVED: 'bg-green-500/20 text-green-700 border-green-500/40',
  MISSING: 'bg-amber-500/20 text-amber-700 border-amber-500/40',
  DAMAGED: 'bg-red-500/20 text-red-700 border-red-500/40',
};

export const ACCESSORY_STATUS_INACTIVE = 'bg-muted text-muted-foreground border-transparent';

/**
 * The received-condition checklist, in the order it is shown.
 *
 * Lives here because the Workspace captures it and the intake preview renders
 * it back. If the two kept their own copies, a label or an ordering could drift
 * and an operator would be reading a different checklist than the one that was
 * filled in.
 */
export type ConditionKey =
  | 'physicalDamage'
  | 'displayCondition'
  | 'waterDamage'
  | 'brokenSeal'
  | 'missingParts'
  | 'tamperEvidence';

export const CONDITION_ITEMS: { key: ConditionKey; label: string }[] = [
  { key: 'physicalDamage', label: 'Physical Damage' },
  { key: 'displayCondition', label: 'Display Condition' },
  { key: 'waterDamage', label: 'Water Damage' },
  { key: 'brokenSeal', label: 'Broken Seal' },
  { key: 'missingParts', label: 'Missing Parts' },
  { key: 'tamperEvidence', label: 'Tamper Evidence' },
];
